// Port de app/registro-diaria.tsx.
import { Carregando } from "@/app/Carregando";
import { lazy } from "react";

const RegistroDiariaScreen = lazy(() => import("@/screens/RegistroDiaria"));

export default function RegistroDiariaRoute() {
  return (
    <Carregando cor="#f2f7f9">
      <RegistroDiariaScreen />
    </Carregando>
  );
}
